<template>
  <span v-html="$t('supportInfo')" />
</template>

<script>
export default {
  name: "ContactSupportInfo"
};
</script>
